import { createFileRoute } from "@tanstack/react-router";
import { SetupManagement } from "@/components/admin/setup-management";

export const Route = createFileRoute("/_auth/app/admin/setups")({
  component: SetupsPage,
});

function SetupsPage() {
  return <SetupManagement />;
}
